export function Spinner({ label = "Loading" }: { label?: string }) {
  return (
    <div style={{ display: "grid", placeItems: "center", padding: 60 }}>
      <div className="spinner" role="status" aria-live="polite" />
      <span className="visually-hidden">{label}</span>
    </div>
  );
}

export function CardSkeletonRow({ count = 7 }: { count?: number }) {
  return (
    <div className="row__track" aria-hidden="true">
      {Array.from({ length: count }, (_, index) => (
        <div key={index} className="card">
          <div className="card__art skeleton" />
        </div>
      ))}
    </div>
  );
}
